import { render } from "./img-report-list.vue?vue&type=template&id=b85fa58e&ts=true"
import script from "./img-report-list.vue?vue&type=script&lang=ts"
export * from "./img-report-list.vue?vue&type=script&lang=ts"

import "./img-report-list.vue?vue&type=style&index=0&id=b85fa58e&lang=scss"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__